import script from "./ModsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ModsView.vue?vue&type=script&setup=true&lang=js"

import "./ModsView.vue?vue&type=style&index=0&id=368fe09a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-368fe09a"]])

export default __exports__